/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

/** Provides authorization to access APIs. */
export interface AuthorizationClient {
  getAccessToken(): Promise<string>;
}
